import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { ImagePlus } from "lucide-react";

const PLACEHOLDER_PROJECTS = [
  { id: "p1", title: "5 Ton System Installation in Walnut", city: "Walnut, CA", equipment: "Carrier 5 Ton — High Efficiency", description: "Full system replacement with new line set and smart thermostat." },
  { id: "p2", title: "Mini Split Installation in Diamond Bar", city: "Diamond Bar, CA", equipment: "Mitsubishi 18k BTU Mini Split", description: "Dual-zone ductless install for a converted garage office." },
  { id: "p3", title: "Commercial HVAC Upgrade in Chino Hills", city: "Chino Hills, CA", equipment: "Rooftop Package Unit", description: "Restaurant rooftop replacement with extended warranty." },
];

const FEATURED_COUNT = 6;

export default function Projects() {
  const { t } = useLang();
  const [projects, setProjects] = useState(PLACEHOLDER_PROJECTS);
  const [showAll, setShowAll] = useState(false);
  useEffect(() => { api.get("/projects").then(r => { if (r.data?.length) setProjects(r.data); }).catch(()=>{}); }, []);

  const visible = showAll ? projects : projects.slice(0, FEATURED_COUNT);
  const hasMore = projects.length > FEATURED_COUNT;

  return (
    <section id="projects" className="section-pad" data-testid="projects">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="text-xs font-bold uppercase tracking-[0.22em] text-ice-400">Recent Work</div>
        <h2 className="mt-3 font-display text-3xl md:text-5xl font-black">{t("projects.title")}</h2>
        <p className="mt-3 text-silver-300 max-w-2xl">{t("projects.sub")}</p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {visible.map((p, i) => (
            <article key={p.id||i} className="card-ink rounded-2xl overflow-hidden" data-testid={`project-${i}`}>
              <div className="aspect-[4/3] bg-ink-700 grid place-items-center relative">
                {p.photos?.[0] ? (
                  <img src={p.photos[0]} alt={p.title} className="w-full h-full object-cover" />
                ) : (
                  <div className="text-silver-500 text-xs uppercase tracking-[0.2em] flex flex-col items-center gap-2">
                    <ImagePlus className="size-6"/> Photo placeholder
                  </div>
                )}
              </div>
              <div className="p-5">
                <div className="text-xs uppercase tracking-[0.2em] text-silver-400">{p.city}</div>
                <h3 className="mt-1 font-display text-lg font-semibold">{p.title}</h3>
                <p className="mt-2 text-sm text-silver-300">{p.description}</p>
                {p.equipment && <div className="mt-3 text-xs text-ice-400 font-semibold">{p.equipment}</div>}
              </div>
            </article>
          ))}
        </div>

        {hasMore && (
          <div className="mt-8 flex justify-center">
            <button
              type="button"
              onClick={() => setShowAll(v => !v)}
              data-testid="projects-toggle-all"
              className="btn-ghost px-6 py-3 rounded-full text-sm"
            >
              {showAll ? "Show fewer projects" : `View all ${projects.length} projects`}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
